// src/components/auth/UserTypeSelection.jsx
import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const UserTypeSelection = () => {
  const { completeGoogleRegistration } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  
  // Get the UID from location state
  const uid = location.state?.uid;
  const from = location.state?.from || '/';
  
  // Form state
  const [userType, setUserType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  
  // Handle radio button change
  const handleChange = (e) => {
    setUserType(e.target.value);
  };
  
  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!userType) {
      setError('Please select a user type');
      return;
    }
    
    if (!uid) {
      setError('User ID not found. Please try signing in again.');
      return;
    }
    
    setLoading(true);
    setError(null);
    
    try {
      // Complete Google registration with user type
      await completeGoogleRegistration(uid, userType);
      
      // Redirect to appropriate dashboard based on user type
      switch (userType) {
        case 'parents':
          navigate('/parent');
          break;
        case 'providers':
          navigate('/provider');
          break;
        case 'jobseekers':
          navigate('/jobseeker');
          break;
        default:
          navigate(from);
      }
    } catch (error) {
      console.error('Registration completion error:', error);
      setError(error.message || 'Failed to complete registration');
    } finally {
      setLoading(false);
    }
  };
  
  return (
    <div className="user-type-selection">
      <h1>Select Your User Type</h1>
      <p>Choose how you'll use the platform:</p>
      
      <form onSubmit={handleSubmit}>
        <div className="user-type-options">
          <label className={`user-type-option${userType === 'parents' ? ' selected' : ''}`}>
            <input
              type="radio"
              name="userType"
              value="parents"
              checked={userType === 'parents'}
              onChange={handleChange}
            />
            <div className="option-content">
              <h3>Parent</h3>
              <p>Looking for childcare services</p>
            </div>
          </label>
          
          <label className={`user-type-option${userType === 'providers' ? ' selected' : ''}`}>
            <input
              type="radio"
              name="userType"
              value="providers"
              checked={userType === 'providers'}
              onChange={handleChange}
            />
            <div className="option-content">
              <h3>Provider</h3>
              <p>Offering childcare services</p>
            </div>
          </label>
          
          <label className={`user-type-option${userType === 'jobseekers' ? ' selected' : ''}`}>
            <input
              type="radio"
              name="userType"
              value="jobseekers"
              checked={userType === 'jobseekers'}
              onChange={handleChange}
            />
            <div className="option-content">
              <h3>Job Seeker</h3>
              <p>Looking for childcare jobs</p>
            </div>
          </label>
        </div>
        
        {error && <div className="error-message">{error}</div>}
        
        <button 
          type="submit" 
          className="submit-button"
          disabled={loading}
        >
          {loading ? 'Processing...' : 'Continue'}
        </button>
      </form>
    </div>
  );
};

export default UserTypeSelection;